import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { PageHeader } from '@/components/PageHeader/page-header';
import { PageConfigProvider } from './page-config-provider';
import { usePageConfigContext } from './use-page-config';
import { listPageContainerStyle } from './list-page-layout.styles';

function ListPageLayoutInner(): ReactElement {
  const { config } = usePageConfigContext();

  return (
    <div style={listPageContainerStyle}>
      {config && (
        <PageHeader
          breadcrumbs={config.breadcrumbs}
          breadcrumbsId={config.breadcrumbsId}
          title={config.title}
          action={config.action}
          secondaryActions={config.secondaryActions}
          description={config.description}
        />
      )}
      <Outlet />
    </div>
  );
}

export function ListPageLayout(): ReactElement {
  return (
    <PageConfigProvider>
      <ListPageLayoutInner />
    </PageConfigProvider>
  );
}
